import { readApiErrorCode } from '@/shared/offer-search/offer-errors';

const UNITS = ['B', 'KiB', 'MiB', 'GiB', 'TiB'];

/**
 * Bytes em texto, base 1024 e unidade binária explícita (KiB, não KB): o bucket
 * cobra por GiB, e o filtro de tamanho da tela também fala MiB.
 */
export function formatBytes(bytes: number): string {
  let value = bytes;
  let unit = 0;
  while (value >= 1024 && unit < UNITS.length - 1) {
    value /= 1024;
    unit++;
  }
  const digits = unit === 0 || value >= 100 ? 0 : 1;
  return `${value.toLocaleString('pt-BR', { maximumFractionDigits: digits })} ${UNITS[unit]}`;
}

export function formatDateTime(iso: string | null): string {
  return iso ? new Date(iso).toLocaleString('pt-BR') : '—';
}

/**
 * Mensagem por `code` do back, nunca o texto cru: até a história 04 do épico
 * files-admin a mensagem de erro do storage trazia o `path`, que repete o nome
 * do upload.
 */
export function describeFileError(err: unknown, fallback: string): string {
  switch (readApiErrorCode(err)) {
    case 'FILE_RECORD_NOT_FOUND':
      return 'Este arquivo não existe ou está fora do seu escopo.';
    case 'FILE_UNDER_LEGAL_HOLD':
      return 'Outra pessoa ligou o legal hold deste arquivo. Desligue o legal hold antes de apagar.';
    case 'FILE_STORAGE_UNAVAILABLE':
      return 'O storage não respondeu. O arquivo pode ter sido apagado do bucket; recarregue para ver o estado atual.';
    case 'FILE_OBJECT_MISSING':
      return 'O objeto deste arquivo não está mais no bucket.';
    case 'FILE_ACCESS_DENIED':
      return 'O storage recusou o acesso ao objeto deste arquivo.';
    default:
      return fallback;
  }
}
